/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {BootstrapVariation} from "../../../../data/bootstrap/bootstrap.variation";
import {BootstrapSize} from "../../../../data/bootstrap/bootstrap.size";
import {withTimeCheck} from "../../hoc/withTimeCheck";

class _Notification extends Component {
    render() {
        const {size, type, message, id, onRemoveNotification} = this.props;
        return message && (
            <div className={`alert alert-${size} alert-${type} p-margin-bottom-sm`}>
                <button type="button" className="close" aria-label="Close">
                    <span onClick={() => onRemoveNotification(id)}>×</span>
                </button>
                <p className="p-sans" dangerouslySetInnerHTML={{__html: message}}/>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    mapping: state.myPuratos_dashboard.mapping,
});
const mapDispatchToProps = {};

_Notification.propTypes = {
    type: PropTypes.string,
    size: PropTypes.string,
    message: PropTypes.string,
    id: PropTypes.string,
    onRemoveNotification: PropTypes.func,
};

_Notification.defaultProps = {
    type: BootstrapVariation.info,
    size: BootstrapSize.small
};

const Notification = withTimeCheck(connect(mapStateToProps, mapDispatchToProps)(_Notification));
export default Notification;
